import { render, staticRenderFns } from "./tabCustomsInfoUICustom.vue?vue&type=template&id=a1cf1d14&"
import script from "./tabCustomsInfoUICustom.vue?vue&type=script&lang=js&"
export * from "./tabCustomsInfoUICustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1cf1d14')) {
      api.createRecord('a1cf1d14', component.options)
    } else {
      api.reload('a1cf1d14', component.options)
    }
    module.hot.accept("./tabCustomsInfoUICustom.vue?vue&type=template&id=a1cf1d14&", function () {
      api.rerender('a1cf1d14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/booking/tabs/tabCustomsInfoUICustom.vue"
export default component.exports